export const Marquee = () => {
  const items = [
    "TEMPAHAN KHAS DIBUKA",
    "PELBAGAI REKA BENTUK",
    "BOLEH CUSTOM",
    "DAPATKAN SANGKAR IDAMAN SI BULUS ANDA",
  ];

  // Repeat multiple times to ensure seamless loop across all viewport widths
  const track = Array.from({ length: 6 }).flatMap(() => items);

  return (
    <div
      data-testid="promo-marquee"
      className="bg-[#1C1C1C] text-[#FAF9F6] border-b border-[#F4F1EA]/5 overflow-hidden"
    >
      <div className="marquee-track flex items-center gap-8 py-3 whitespace-nowrap">
        {track.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-8 text-[11px] sm:text-xs tracking-[0.28em] font-bold uppercase">
            <span className="text-[#E07A5F]">◆</span>
            <span>{t}</span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes marquee-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .marquee-track {
          width: max-content;
          animation: marquee-scroll 45s linear infinite;
        }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
};
